import { defineComponent, h, type App } from "vue";
import VueInlineSvg from "vue-inline-svg";
import { toStaticAssetUrl } from "@/core/helpers/staticAssets";

const InlineSvg = defineComponent({
  name: "InlineSvg",
  inheritAttrs: false,
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  setup(props, { attrs }) {
    return () =>
      h(VueInlineSvg, {
        ...attrs,
        src: toStaticAssetUrl(props.src),
      });
  },
});

/**
 * Initialize Inline-Svg component
 * @param app vue instance
 */
export function initInlineSvg(app: App<Element>) {
  app.component("InlineSvg", InlineSvg);
}
